<template>
  <div class="main">
    <c-panel title="Execução de Rotas" titleIcon="fas fa-clipboard-check">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

